import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { faqs } from '@/mocks/faqs';

export default function AboutPage() {
  const [openFaqId, setOpenFaqId] = useState<string | null>(null);

  return (
    <>
      <SEOHead
        title="关于我们"
        description="了解众赢zygjb官方平台的品牌故事、发展历程、信誉保障及联系方式。众赢zygjb致力于为玩家提供安全、稳定、优质的游戏平台体验。"
        keywords="众赢zygjb关于我们,众赢品牌介绍,众赢信誉,众赢联系方式,zygjb平台"
        canonicalUrl="https://zylogin.github.io/about"
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <div className="pt-20 pb-4 bg-gradient-to-b from-background-100 to-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <Breadcrumb items={[{ label: '首页', path: '/' }, { label: '关于我们' }]} />
          </div>
        </div>

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-14">
              <div className="w-16 h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-5">
                <i className="ri-building-4-line text-2xl text-primary-600"></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                关于众赢zygjb
              </h1>
              <p className="text-sm text-foreground-600 max-w-xl mx-auto">
                致力于为玩家提供安全、稳定、优质的游戏平台体验
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
              <div>
                <h2 className="font-heading font-semibold text-foreground-900 text-lg mb-4">
                  品牌介绍
                </h2>
                <div className="space-y-3 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    众赢zygjb是国内知名的在线游戏平台品牌，多年来始终秉持&ldquo;安全第一、玩家至上&rdquo;的运营理念，为数百万玩家提供优质的游戏体验服务。平台汇聚了丰富的游戏资源和专业的运营团队，致力于打造行业领先的游戏生态体系。
                  </p>
                  <p>
                    作为业内信誉卓著的平台，众赢zygjb采用国际先进的加密技术和安全防护体系，确保每一位玩家的账号安全和个人信息得到最严格的保护。平台拥有完善的客户服务体系，7&times;24小时全天候为玩家提供专业的咨询和支持。
                  </p>
                  <p>
                    众赢zygjb持续投入技术研发，不断优化平台性能和用户体验。从界面设计到底层架构，每一个细节都经过精心打磨，只为给玩家带来流畅、舒适的游戏环境。
                  </p>
                </div>
              </div>
              <div>
                <h2 className="font-heading font-semibold text-foreground-900 text-lg mb-4">
                  发展历程
                </h2>
                <div className="space-y-5">
                  {[
                    {
                      year: '2026',
                      title: '平台全面升级',
                      desc: '完成新一轮技术架构升级，用户体验全面提升，全球服务器节点扩展至50+。',
                    },
                    {
                      year: '2025',
                      title: '用户突破百万',
                      desc: '平台注册用户突破百万大关，成为行业内增长最快的游戏平台之一。',
                    },
                    {
                      year: '2024',
                      title: '品牌升级',
                      desc: '正式启用"众赢zygjb"品牌，推出全新平台界面和功能体系。',
                    },
                    {
                      year: '2023',
                      title: '平台创立',
                      desc: '核心团队组建完成，平台正式上线运营，首月即获得玩家广泛好评。',
                    },
                  ].map((item, idx) => (
                    <div key={idx} className="flex gap-4">
                      <div className="flex-shrink-0 w-14 text-right">
                        <span className="text-xs font-semibold text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                          {item.year}
                        </span>
                      </div>
                      <div>
                        <h3 className="font-medium text-foreground-900 text-sm mb-1">
                          {item.title}
                        </h3>
                        <p className="text-xs text-foreground-600">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                信誉保障
              </h2>
              <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                众赢zygjb以诚信为本，以实际行动赢得玩家信赖
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                {
                  icon: 'ri-shield-star-line',
                  title: '安全认证',
                  desc: '通过国际安全标准认证，采用SSL加密和多重防火墙防护。',
                },
                {
                  icon: 'ri-user-heart-line',
                  title: '百万用户',
                  desc: '累计服务超过百万玩家，用户满意度持续保持在98%以上。',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '专业客服',
                  desc: '7×24小时全天候在线，专业客服团队快速响应各类问题。',
                },
                {
                  icon: 'ri-award-line',
                  title: '行业认可',
                  desc: '多次获得行业权威机构颁发的"最佳游戏平台"等荣誉奖项。',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="p-6 rounded-2xl bg-white border border-background-200/70 text-center"
                >
                  <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-xl text-accent-600`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 mb-2 text-sm">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                联系我们
              </h2>
              <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                如有任何问题或建议，欢迎通过以下方式与我们联系
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
              <div className="p-6 rounded-2xl bg-white border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1 text-sm">
                  在线客服
                </h3>
                <p className="text-xs text-foreground-500 mb-2">7×24小时在线服务</p>
                <a
                  href="#"
                  className="text-sm text-primary-600 font-medium hover:text-primary-700"
                >
                  立即咨询
                </a>
              </div>
              <div className="p-6 rounded-2xl bg-white border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-mail-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1 text-sm">
                  客服邮箱
                </h3>
                <p className="text-xs text-foreground-500 mb-2">官方客服邮箱</p>
                <a
                  href="mailto:support@zygjb.com"
                  className="text-sm text-primary-600 font-medium hover:text-primary-700"
                >
                  support@zygjb.com
                </a>
              </div>
              <div className="p-6 rounded-2xl bg-white border border-background-200/70 text-center">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-4">
                  <i className="ri-briefcase-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="font-heading font-semibold text-foreground-900 mb-1 text-sm">
                  商务合作
                </h3>
                <p className="text-xs text-foreground-500 mb-2">商务合作咨询</p>
                <a
                  href="mailto:biz@zygjb.com"
                  className="text-sm text-primary-600 font-medium hover:text-primary-700"
                >
                  biz@zygjb.com
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full py-12 md:py-16 bg-background-100">
          <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-600">
                快速了解众赢zygjb平台，如有更多疑问请联系客服
              </p>
            </div>
            <div className="max-w-3xl mx-auto space-y-3">
              {faqs.map((faq) => (
                <div
                  key={faq.id}
                  className="rounded-xl border border-background-200/70 bg-white overflow-hidden"
                >
                  <button
                    onClick={() => setOpenFaqId(openFaqId === faq.id ? null : faq.id)}
                    className="w-full flex items-center justify-between p-5 text-left"
                  >
                    <h3 className="font-medium text-foreground-900 text-sm pr-4">
                      {faq.question}
                    </h3>
                    <div
                      className={`w-7 h-7 rounded-full bg-background-100 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                        openFaqId === faq.id ? 'rotate-45' : ''
                      }`}
                    >
                      <i className="ri-add-line text-foreground-600 text-xs"></i>
                    </div>
                  </button>
                  <div
                    className={`transition-all duration-300 overflow-hidden ${
                      openFaqId === faq.id ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于众赢zygjb',
            description:
              '了解众赢zygjb官方平台的品牌故事、发展历程、信誉保障及联系方式。',
            url: 'https://zylogin.github.io/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '众赢zygjb官方入口',
              url: 'https://zylogin.github.io',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://zylogin.github.io' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          }),
        }}
      />
    </>
  );
}